import { useMutation, useQuery } from "react-query";
import usersApi from "../apis/users";

const { getAllUsers, createNewInvite, updateSourceAdmin } = usersApi;
export const useGetAllUsers = (remark, pageNum, pageSize, onSuccess, onError) =>
  useQuery(
    ["" + remark, pageNum, pageSize],
    () => getAllUsers(pageNum, pageSize),
    {
      onSuccess,
      onError,
      refetchOnWindowFocus: false,
    }
  );
export const useCreateNewInvite = (onSuccess, onError) => {
  return useMutation({
    mutationFn: (payload) => {
      return createNewInvite(payload);
    },
    onSuccess,
    onError,
  });
};
export const useUpdateSourceAdmin = (onSuccess, onError) => {
  return useMutation({
    mutationFn: (payload) => {
      return updateSourceAdmin(payload);
    },
    onSuccess,
    onError,
  });
};
